export default __webpack_public_path__ + "static/media/chat-app.63ae399f.png";